var _path, _circle, _circle2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDiscount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12L12 8",
    stroke: "#FF00CE",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 0.5,
    fill: "#FF00CE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 0.5,
    fill: "#FF00CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26941 2.78169C9.66467 2.35879 10.3353 2.35879 10.7306 2.78169L11.9858 4.12477C12.183 4.33569 12.4617 4.45113 12.7502 4.44138L14.5875 4.37928C15.166 4.35973 15.6403 4.83396 15.6207 5.41249L15.5586 7.24979C15.5489 7.53833 15.6643 7.81701 15.8752 8.01415L17.2183 9.26941C17.6412 9.66467 17.6412 10.3353 17.2183 10.7306L15.8752 11.9858C15.6643 12.183 15.5489 12.4617 15.5586 12.7502L15.6207 14.5875C15.6403 15.166 15.166 15.6403 14.5875 15.6207L12.7502 15.5586C12.4617 15.5489 12.183 15.6643 11.9858 15.8752L10.7306 17.2183C10.3353 17.6412 9.66467 17.6412 9.26941 17.2183L8.01415 15.8752C7.81701 15.6643 7.53834 15.5489 7.24979 15.5586L5.41249 15.6207C4.83396 15.6403 4.35973 15.166 4.37928 14.5875L4.44138 12.7502C4.45113 12.4617 4.33569 12.183 4.12477 11.9858L2.78169 10.7306C2.35879 10.3353 2.35879 9.66467 2.78169 9.26941L4.12477 8.01415C4.33569 7.81701 4.45113 7.53834 4.44138 7.24979L4.37928 5.41249C4.35973 4.83396 4.83396 4.35973 5.41249 4.37928L7.24979 4.44138C7.53833 4.45113 7.81701 4.33569 8.01415 4.12477L9.26941 2.78169Z",
    stroke: "#FF00CE",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDiscount);
export default __webpack_public_path__ + "static/media/ic_discount.5a322a0e8d726bb28ed3d3a8baa803b8.svg";
export { ForwardRef as ReactComponent };